module.exports = __webpack_public_path__ + "static/media/salef_for_it_small.61619bd5.jpg";